import comp from "./MultiSelectComponentV2";
export default comp;
